import React from 'react';
import './Profile.css';

const Profile = ({ picture, name, surname, jobTitle, description, languages, imageSize }) => {
  return (
    <section className="profile-container">
      <div className="profile-details">
        <p className="text-sm font-semibold uppercase tracking-[0.18em] text-[var(--accent-green)]">
          Professional profile
        </p>
        <h1 className="profile-name mt-2 text-3xl font-bold text-[var(--text-primary)] md:text-4xl">{name} {surname}</h1>
        <h2 className="profile-job-title mt-1 text-xl font-semibold text-[var(--accent-gold)]">{jobTitle}</h2>
        <div className="profile-description mt-5 space-y-2 text-base leading-relaxed text-[var(--text-secondary)]">
            {description.map((item, index) => (
              <p key={index}>{item}</p>
            ))}
        </div>
        <div className="mt-5 flex flex-wrap gap-2">
          {languages.map((language) => (
            <span key={language} className="rounded-full border border-[var(--border-color)] px-3 py-1 text-sm text-[var(--text-secondary)]">
              {language}
            </span>
          ))}
        </div>
      </div>
      <div className="profile-picture">
        <img src={picture} alt={`${name} ${surname}`} style={{ width: imageSize, height: 'auto' }}/>
      </div>
    </section>
  );
};

export default Profile;
